
import BaseButton from "@/components/base/BaseButton.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import useAccount from "@/composables/useAccount";
import useAccountPages from "@/composables/useAccountPages";
import { getQueryParamValue } from "@/helpers/urlHelper";
import { Component } from "@/models/enums";
import useVuelidate from "@vuelidate/core";
import { helpers, maxLength, minLength, required } from "@vuelidate/validators";
import { defineComponent, reactive, ref } from "vue";

export default defineComponent({
	components: { BaseInput, BaseButton, BaseSpinner },
	setup() {
		const { setComponent } = useAccountPages();
		const { validateResetToken, resetPassword } = useAccount();
		const loading = ref(true);

		const id = getQueryParamValue("id");
		if (!id) {
			setComponent(Component[Component.AccountLogin]);
		} else {
			validateResetToken(id).then((res) => {
				if (!res) {
					setComponent(Component[Component.AccountLogin]);
				} else {
					loading.value = false;
				}
			});
		}

		const state = reactive({
			password: "",
			passwordConfirm: "",
		});

		const rules = {
			password: {
				required,
				min: helpers.withMessage(() => "Minimum 6 characters", minLength(6)),
				max: helpers.withMessage(() => "Maximum 10 characters", maxLength(10)),
			},
			passwordConfirm: {
				v: helpers.withMessage(
					() => "Passwords do not match",
					(value: string) => value === state.password
				),
			},
		};

		const v$ = useVuelidate(rules, state);

		const submitForm = async () => {
			v$.value.$touch();
			const valid = await v$.value.$validate();

			if (valid) {
				resetPassword(id, state.password, state.passwordConfirm).then((res) => {
					if (res) {
						setComponent(Component[Component.AccountLogin]);
					}
				});
			}
		};

		return { submitForm, v$, loading };
	},
});
